"use strict";

/**
* Ссылка.
* 
* @class WebAccess.components.wrappers.form.Link
* @extends  WebAccess.components.wrappers.BasePageElement
* @property {string} name Имя ссылки
* @property {string} selector Путь в DOM-иерархии к объекту группы, например div.content#container
* @param {string} itemSelector Cуществующий элемент страницы
*/
(function (global) {
   
  var Link = global.components.wrappers.BasePageElement.extend({

    init: function (itemSelector) {
      this._super(itemSelector);
      this.name = this._jObject.attr('id');
      this.selector = "#" + this.name;
      this.actionName = this._jObject.data('action-name');
    },     

    className: "Link",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~// 

    /**
    * Имитировать щелчок мыши.
    * Имитация щелчка мыши по ссылке либо установка обработчика на событие onClick, если передан callback. 
    * Заменяет обработчик по умолчанию.
    * 
    * @param {function} [opt_callback] Функция, которая будет вызвана после щелчка мыши по ссылке
    * @method  WebAccess.components.wrappers.form.Link#click    
    * @return {button}
    */
    click: function (opt_callback) {
      var me = this;
      if ($.isFunction(opt_callback)) {
        var jObject = me._jObject;
        me._super(function () {
          if (!jObject.hasClass('disabled')) opt_callback();
        });
        jObject.addClass('binded');
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Подписка на события
    *          
    * @param {string} event
    * @method  WebAccess.components.wrappers.form.Link#bind
    * @return { WebAccess.components.wrappers.form.Link}
    */
    bind: function (event, callback) {
      var me = this;
      if ($.isFunction(callback)) {
        var jObject = me._jObject;
        me._super(event, function () {
          if (!jObject.hasClass('disabled')) callback();
        });
        jObject.addClass('binded');
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отключение ссылки
    * 
    * @method  WebAccess.components.wrappers.form.Link#disable
    * @return { WebAccess.components.wrappers.form.Link}
    * @see module:tests/FormControls~isLinkRealyDisabled
    */
    disable: function () {
      if (this.isEnabled()) {
        this._super();
        this._jObject.addClass('disabled');
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включение ссылки, если она была отключена ранее.
    * 
    * @method  WebAccess.components.wrappers.form.Link#enable
    * @return { WebAccess.components.wrappers.form.Link}
    * @see module:tests/FormControls~isLinkRealyEnabled
    */
    enable: function () {
      if (!this.isEnabled()) {
        this._super();
        this._jObject.removeClass('disabled');
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить подпись ссылки
    * 
    * @method  WebAccess.components.wrappers.form.Link#getLabel
    * @return {string}
    * @see module:tests/FormControls~getLabelValue
    */
    getLabel: function() {      
      return this._jObject.text();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить подпись ссылки
    * 
    * @method  WebAccess.components.wrappers.form.Link#setLabel
    * @param {string} text текст подписи
    * @see module:tests/FormControls~setLabelValue
    * @return {link}
    */
    setLabel: function(text) {
      this._jObject.text(text);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @ignore
    * @method  WebAccess.components.wrappers.form.Link#setIcon
    */
    setIcon: function (path) {
      global.raise("ERR_UNSUPPORTED_METHOD");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @ignore
    * @method  WebAccess.components.wrappers.form.Link#getIcon
    */
    getIcon: function (path) {      
      global.raise("ERR_UNSUPPORTED_METHOD");
      return this;
    },

    /**
     * Отобразить гиперссылку.
     * 
     * @method WebAccess.components.wrappers.form.Link#show
     * @return {WebAccess.components.wrappers.form.Link} Объект типа Link.
    */
    show: function () {
      this._jObject.css('visibility', 'visible');
      this.fire("show");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть гиперссылку.
    * 
    * @method WebAccess.components.wrappers.form.Link#hide
    * @return {WebAccess.components.wrappers.form.Link} Объект типа Link.
    */
    hide: function () {
      this._jObject.css('visibility', 'hidden');
      this.fire("hide");
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.components.wrappers.form.Link = Link;
})(window.WebAccess);